import { OrganizationRes } from '../api';

import { Organization } from './organizations.abstraction';

export class OrganizationsUtility {
  static toOrganization(organization: OrganizationRes): Organization {
    const capabilities = organization.capabilities;
    const membership = organization.membership;
    const portalRole = organization.portalRole;

    return {
      capabilities: {
        grantableRoles: [...capabilities.grantableRoles],
        portal: { ...capabilities.portal },
      },
      createdAt: organization.createdAt,
      createdBy: { ...organization.createdBy },
      id: organization.id,
      membership: membership ? { ...membership } : null,
      name: organization.name,
      portalRole: portalRole ? { ...portalRole } : null,
      status: organization.status,
      tenantKey: organization.tenantKey,
    };
  }
}
